export default __webpack_public_path__ + "static/pc-carousel-05-a82507b8fdf4f36fc5939735a5f5a8ee.jpg";